import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FlyingFocusComponent } from './flying-focus/flying-focus.component';
import { FlyingFocusDirective } from './flying-focus/flying-focus.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [FlyingFocusComponent, FlyingFocusDirective],
    exports: [FlyingFocusDirective]
})
export class FlyingFocusModule {}
